{
  "GENERAL": {
    "CLOSE": "Aizvērt",
    "SHOWING_RESULTS": "Rāda {firstIndex}-{lastIndex} no {totalCount} vienībām",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Meklēt",
      "EMPTY_STATE": "Nav atrasts"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Nepieciešams vismaz {count}"
  }
}
